import { all } from 'redux-saga/effects'

import { sagas as authSagas } from '../../auth'
import { sagas as cmsJobsSagas } from '../../cmsPage'
import { sagas as companyJobsSagas } from '../../companyJobs'
import { sagas as companyProfileSagas } from '../../companyProfile'
import { sagas as copyToClipboardSagas } from '../../copyToClipboard'
import { sagas as jobApplicationSagas } from '../../jobapplication'
import { sagas as jobDetailSagas } from '../../jobDetail'
import { sagas as jobMailSagas } from '../../jobmail'
import { sagas as jobMailUnsubscribeSagas } from '../../jobmailUnsubscribePage'
import { sagas as ratingWidgetSagas } from '../../ratingWidget'
import { sagas as resultsSagas } from '../../results'
import { sagas as searchSagas } from '../../search'
import { sagas as shareSagas } from '../../share'
import { sagas as similarJobsSagas } from '../../similarJobs'
import { sagas as trackingSagas } from '../../tracking'

export default function * root () {
  yield all([
    // fetch company detail
    companyProfileSagas,
    // jobmail
    jobMailSagas,
    // jobmail unsubscribe
    jobMailUnsubscribeSagas,
    // jobapplication
    jobApplicationSagas,
    // search
    searchSagas,
    // copy to clipboard
    copyToClipboardSagas,
    // share
    shareSagas,
    // company jobs
    companyJobsSagas,
    // jobs for cms article
    cmsJobsSagas,
    // job detail
    jobDetailSagas,
    // authentication
    authSagas,
    // tracking
    trackingSagas,
    // results
    resultsSagas,
    // similar jobs
    similarJobsSagas,
    // jobboersencheck.de rating widget
    ratingWidgetSagas
  ])
}
